import { render, staticRenderFns } from "./bheader.vue?vue&type=template&id=35965c6a&scoped=true&"
import script from "./bheader.vue?vue&type=script&lang=js&"
export * from "./bheader.vue?vue&type=script&lang=js&"
import style0 from "./bheader.vue?vue&type=style&index=0&id=35965c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35965c6a",
  null
  
)

export default component.exports